import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ArgCalcularRemesasSeguroDTO, ArgumentosCalcularRemesasDTO, ArgumentosConsultarStatusDTO, ArgumentosGrabarRemesasDTO, ArgumentosGrabarRemesasSeguros } from "../models/remesas";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { selectorTransversal } from "../../../../dtos/selector";
const BASEURL = 'siscred-api-dividendos/v1/remesas/';

const getCompanias = async () => {
    const response: AxiosResponse<ListResponseDto<selectorTransversal>> = await axiosInstance.get(`${BASEURL}obtener-companias-seguro`);
    return response;
}
const getPolizaByName = async (name: string) => {
    const response: AxiosResponse = await axiosInstance.get(`${BASEURL}obtener-polizas-seguro`, { params: { name: name } });
    return response;
}
const getCalculoRemesa = async (data: ArgumentosCalcularRemesasDTO) => {
    const response: AxiosResponse = await axiosInstance.post(`${BASEURL}obtener-calculo-remesas`, data)
    return response;
}

const getStatusRemesa = async (data: ArgumentosConsultarStatusDTO) => {
    const response: AxiosResponse = await axiosInstance.post(`${BASEURL}obtener-status-remesas`, data)
    return response;
}

const postRemesa = async (data: ArgumentosGrabarRemesasDTO) => {
    const response: AxiosResponse = await axiosInstance.post(`${BASEURL}grabar-remesas`, data)
    return response;
}

const getCalculoRemesaSeguros = async (data: ArgCalcularRemesasSeguroDTO) => {
    const response: AxiosResponse = await axiosInstance.post(`${BASEURL}obtener-calculo-remesas-seguros`, data)
    return response;
}

const postRemesaSeguros = async (data: ArgumentosGrabarRemesasSeguros) => {
    const response: AxiosResponse = await axiosInstance.post(`${BASEURL}grabar-remesas-seguros`, data)
    return response;
}

export { getCompanias, getPolizaByName, getCalculoRemesa, getStatusRemesa, postRemesa, getCalculoRemesaSeguros, postRemesaSeguros }